<template>
  <v-container
    ma-0
    pa-0
  >
    <v-layout
      row
      wrap
      v-show="!facebookLoginState"
    >
      <v-flex xs12 v-if="!isCapacitorEnv">
        <div
          class="fb-login-button"
          :scope="facebookPermissions.join(',')"
          data-width="220"
          data-size="medium"
          data-button-type="login_with"
          data-layout="default"
          data-auto-logout-link="true"
          data-use-continue-as="false"
          onlogin="checkLoginState"
        />
      </v-flex>
      <v-flex shrink v-else>
        <v-btn
          @click="loginFacebook"
          class="facebook-login-button"
        >
          <v-img
            :src="facebookIcon"
            alt="Facebook Icon"
            width="24"
            height="24"
            class="text-left"
          />
          {{ $t('message.bizgainOnboarding.loginWithFacebook') }}
        </v-btn>
      </v-flex>
      <v-flex v-if="showNoAccountsMessage" class="pt-1" xs12>
        <span
          class="caption grey--text"
        > {{ $t('message.bizgainOnboarding.noAccessMessage') }} </span>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        xs12
        md6
        lg4
        v-if="facebookLoginState && accounts.length > 0"
      >
        <v-select
          dense
          v-model="selectedPageObj"
          id="pageSelectList"
          class="select-small-variant assets-select pt-0 mt-0"
          :items="accounts"
          item-text="name"
          item-value="id"
          hide-details
          :menu-props="{ top: true }"
          :return-object="true"
          @change="getSelectedPageDetails"
          :placeholder="$tc('message.bizgainOnboarding.selectPage')"
          append-icon="keyboard_arrow_down"
        >
          <template v-slot:selection="data">
            <v-list-tile-avatar size="25px" class="avatar">
              <v-img contain :src="data.item.Logo" />
            </v-list-tile-avatar>
            <v-list-tile-content class="text-ellipsis">
              <v-list-tile-title
                class="ml-1 body-1"
              >
                {{ data.item.name }}
              </v-list-tile-title>
            </v-list-tile-content>
          </template>
          <template v-slot:item="data">
            <span class="d-flex">
              <v-list-tile-avatar size="25px" class="avatar">
                <v-img :src="data.item.Logo" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ data.item.name }}
                </v-list-tile-title>
              </v-list-tile-content>
            </span>
          </template>
        </v-select>
      </v-flex>
      <v-flex
        xs12
        md6
        lg8
        :class="{ 'pl-3': !$vuetify.breakpoint.smAndDown && !showNoAccountsMessage }"
        v-if="facebookLoginState && !showNoAccountsMessage"
      >
        <v-layout
          align-end
          justify-start
          :class="{ 'pt-3': $vuetify.breakpoint.smAndDown }"
        >
          <a class="logout" @click="logoutUser">{{ $tc('message.bizgainOnboarding.logoutToUseDifferentaccount') }}</a>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {
  VFlex,
  VSelect,
  VListTileAvatar,
  VListTileContent,
  VListTileTitle,
  VLayout,
  VImg,
  VContainer,
  VBtn
} from 'vuetify/lib';
import { mapActions, mapGetters } from 'vuex';
import { FacebookHelper } from 'Helpers/facebookHelper';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import { EngineConfigurationService } from 'AppServices/engineConfigurationService';
import { GraphApiService } from '../../../services/graphApiService';
import { bizgainConfig } from 'Features/bizgainOnboarding/constants';
const {
  getAccountPages
} = new GraphApiService();
export default {
  components: {
    VFlex,
    VSelect,
    VListTileAvatar,
    VListTileContent,
    VListTileTitle,
    VLayout,
    VImg,
    VContainer,
    VBtn
  },
  data() {
    return {
      fbPlugin: null,
      facebookHelper: null,
      accounts: [],
      selectedPageObj: null,
      showNoAccountsMessage: false,
      assetsLinkingSuccess: false,
      facebookPermissions: ['email', 'public_profile', 'ads_management', 'pages_show_list', 'business_management', 'read_insights', 'leads_retrieval', 'catalog_management', 'pages_manage_ads', 'pages_manage_metadata', 'pages_read_engagement', 'pages_read_user_content', 'pages_manage_posts'],
      fbLogin: null,
      accessToken: null,
      facebookIcon: bizgainConfig.facebookIcon,
      engineConfigurationService: null
    }
  },
  async created() {
    this.engineConfigurationService = new EngineConfigurationService();
    this.facebookHelper = new FacebookHelper();
    if (this.isCapacitorEnv)
    {
      let facebookAppId = await this.engineConfigurationService.getFacebookAppId();
      await FacebookLogin.initialize({ appId: facebookAppId });
      this.fbLogin = FacebookLogin;
      await this.getCurrentAccessToken();
    } else {
      await this.facebookHelper.setUpFacebookLogin(this.checkLoginState);
      await this.checkLoginState();
      await this.initStatusChangeEvent()
      if (this.facebookLoginState && this.accounts.length > 0 && this.selectedFacebookPageId) {
        let selectedPageObj = this.accounts.find(x => x.id == this.selectedFacebookPageId);
        if (selectedPageObj) {
          this.selectedPageObj = selectedPageObj;
          this.getSelectedPageDetails();
        }
      }
    }
  },
  computed: {
    ...mapGetters(['facebookLoginState', 'selectedFacebookPageId']),
    isCapacitorEnv(){
      return process.env.VUE_APP_CAPACITOR_ENVIRONMENT === 'true';
    }
  },
  methods: {
    ...mapActions(['setIsFbLoadCompleted', 'setFacebookLoginState', 'setFacebookPageDetail']),
    async initStatusChangeEvent(){
      if(window && window.FB){
        window.FB.Event.subscribe('auth.statusChange', async (response)=> {
          this.setIsFbLoadCompleted(true);
          if(response.status == 'connected'){
            await this.getFacebookAccounts();
            this.setFacebookLoginState(true);
          }else {
            this.logoutUser();
          }
          this.setIsFbLoadCompleted(false);
        });
      }
    },
    async checkLoginState() {
      this.setIsFbLoadCompleted(true);
      let isUserLoggedIn = await this.facebookHelper.getFabookLoginStatus();
      if (isUserLoggedIn) {
        await this.getFacebookAccounts();
        if(this.showNoAccountsMessage){
          this.logoutUser();
        }
        this.$emit('fbOAuthCompleted');
        this.setFacebookLoginState(true);
      } else {
        this.facebookHelper.loginUser();
      }
      this.setIsFbLoadCompleted(false);
    },
    async getCurrentAccessToken(){
      try {
        const result = await this.fbLogin.getCurrentAccessToken();
        if (result.accessToken) {
          this.accessToken = result.accessToken.token;
          this.setFacebookLoginState(true);
          this.getFacebookAccounts();
          this.$emit('fbOAuthCompleted');
        }
      } finally {
        this.setIsFbLoadCompleted(false);
      }
    },
    async loginFacebook(){
      const result = await this.fbLogin.login({ permissions: this.facebookPermissions });

      if (result.accessToken) {
        this.accessToken = result.accessToken.token;
        this.setFacebookLoginState(true);
        await this.getFacebookAccounts();
        this.$emit('fbOAuthCompleted');
      }
    },
    async getFacebookAccounts() {
      let response = null;
      let fields = 'accounts{picture{url},name,access_token,phone,category_list,hours,contact_address,description,website,about,location,link}'
      if(this.isCapacitorEnv)
      {
        response = await getAccountPages(this.accessToken, fields);
      } else {
        response = await this.facebookHelper.facebookApiFunction(`me?fields=${fields}`);
      }
      if (
        !response ||
            !response.accounts ||
            !response.accounts.data ||
            !response.accounts.data.length
      ) {
        this.showNoAccountsMessage = true;
      }
      else {
        this.accounts = response.accounts.data.map(account => {
          return {
            id: account.id,
            name: account.name,
            Logo: account.picture.data.url,
            accessToken: account.access_token,
            categories: account.category_list && account.category_list.map(x => x.name),
            hours: account.hours,
            description: account.description,
            website: account.website,
            about: account.about,
            location: account.location,
            phoneNumber: account.phone,
            pageUrl: account.link
          };
        });
        if (this.accounts && Array.isArray(this.accounts) && this.accounts.length > 0) {
          this.selectedPageObj = this.accounts[0];
          this.getSelectedPageDetails();
        }
      }
    },
    getSelectedPageDetails() {
      this.$emit('LinkedPageDetails', this.selectedPageObj);
    },
    async logoutUser() {
      if (this.isCapacitorEnv)
      {
        await this.fbLogin.logout();
      } else {
        let isUserLoggedOut = await this.facebookHelper.logoutUser();
        if (isUserLoggedOut) {
          await this.facebookHelper.setUpFacebookLogin(this.checkLoginState);
        }
      }
      this.setFacebookLoginState(false);
      this.accounts = [];
      this.selectedPageObj = null;
      this.getSelectedPageDetails();
      this.setFacebookPageDetail(null);
    }
  }
}
</script>
<style scoped>
::v-deep.logout {
  text-decoration: underline;
  columns: var(--v-primary-base);
  font-size: 15px;
  line-height: 1.33;
}
::v-deep.avatar {
  min-width: 30px;
}
::v-deep.text-ellipsis {
  text-align: left !important;
  width: 14vw !important;
}
::v-deep.facebook-login-button{
  background-color: #166fe5 !important;
  color: white;
}
::v-deep.select-small-variant .v-select__selections{
  flex-wrap: nowrap;
}
</style>